import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { LanguageContext } from "common/contexts/LanguageContext";
import { US_English_Locale } from "common/constants/GlobalValues";

const OpenGraphMetaTags = () => {
  const { selectedLanguageLocale } = useContext(LanguageContext);
  const baseUrl = window.location.origin;

  console.log(baseUrl);

  return (
    <>
      {selectedLanguageLocale === US_English_Locale ? (
        <Helmet>
          {/* <!-----Open Graph---> */}

          {/* <!--Facebook----> */}

          <meta property="og:type" content="website" />

          <meta property="og:title" content="Wireless Device Network Panning & Design | Emerson US" />

          <meta
            property="og:description"
            content="Use this tool to upload an aerial image of your facility and design a wireless network while checking against industry best practices."
          />

          <meta
            property="og:image"
            content={`${baseUrl}/assets/images/Corp_RGB_Standard_Digital.png`}
          />

          <meta property="og:url" content={`${baseUrl}`} />

          <meta property="og:site_name" content="Emerson.com" />

          {/* <!--Twitter--> */}

          <meta name="twitter:card" content="summary_large_image" />

          <meta name="twitter:title" content="Wireless Device Network Panning & Design | Emerson US" />

          <meta
            name="twitter:description"
            content="Use this tool to upload an aerial image of your facility and design a wireless network while checking against industry best practices"
          />

          <meta
            name="twitter:image"
            content={`${baseUrl}/assets/images/Corp_RGB_Standard_Digital.png`}
          />

          <meta name="twitter:image:alt" content="wireless devices design" />

          <meta name="twitter:site" content="@Rosemount_News" />

          <meta name="twitter:creator" content="@Rosemount_News" />

          {/* <!---End Open Graph---> */}
        </Helmet>
      ) : (
        <Helmet>
          {/* <!-----Open Graph---> */}

          {/* <!--Facebook----> */}
          <meta property="og:type" content="website" />

          <meta property="og:title" content="Wireless Device Network Panning & Design | Emerson US" />

          <meta
            property="og:description"
            content="Use this tool to upload an aerial image of your facility and design a wireless network while checking against industry best practices."
          />

          <meta
            property="og:image"
            content={`${baseUrl}/assets/images/Corp_RGB_Standard_Digital.png`}
          />

          <meta property="og:url" content={`${baseUrl}`} />

          <meta property="og:site_name" content="Emerson.com" />

          {/* <!--Twitter--> */}

          <meta name="twitter:card" content="summary_large_image" />

          <meta name="twitter:title" content="Wireless Device Network Panning & Design | Emerson US" />

          <meta
            name="twitter:description"
            content="Use this tool to upload an aerial image of your facility and design a wireless network while checking against industry best practices"
          />

          <meta
            name="twitter:image"
            content={`${baseUrl}/assets/images/Corp_RGB_Standard_Digital.png`}
          />

          <meta name="twitter:image:alt" content="wireless devices design" />

          <meta name="twitter:site" content="@Rosemount_News" />

          <meta name="twitter:creator" content="@Rosemount_News" />

          {/* <!---End Open Graph---> */}
        </Helmet>
      )}
    </>
  );
};

export default OpenGraphMetaTags;
